/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DealDTO } from '../models/DealDTO';
import type { PageDealDTO } from '../models/PageDealDTO';
import type { PageMyDealDTO } from '../models/PageMyDealDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomDealResourceService {
    /**
     * Get the deal dto requested
     * Retrieves the deal dto requested
     * @returns DealDTO OK
     * @throws ApiError
     */
    public static getDeal1({
        dealId,
    }: {
        /**
         * The id of the deal requested
         */
        dealId: number,
    }): CancelablePromise<DealDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/deal/{dealId}',
            path: {
                'dealId': dealId,
            },
        });
    }
    /**
     * Get list of all deals associated to a signaller
     * Retrieves a list of all deals with status and lead email for a signaller
     * @returns PageMyDealDTO OK
     * @throws ApiError
     */
    public static getSignallerDeals({
        signallerId,
        page,
        size = 5,
        sortBy = 'dateUpdate',
        sortDir = 'desc',
    }: {
        /**
         * The signaller ID to filter by
         */
        signallerId: number,
        /**
         * The page number for pagination
         */
        page?: number,
        /**
         * The number of items page for pagination
         */
        size?: number,
        /**
         * The field to sort the results by
         */
        sortBy?: string,
        /**
         * The sorting direction
         */
        sortDir?: string,
    }): CancelablePromise<PageMyDealDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/deal/signaller-deals/{signallerId}',
            path: {
                'signallerId': signallerId,
            },
            query: {
                'page': page,
                'size': size,
                'sortBy': sortBy,
                'sortDir': sortDir,
            },
        });
    }
    /**
     * Get list of all deals associated to a lead
     * Retrieves a paginated list of all deals associated to a lead
     * @returns PageDealDTO OK
     * @throws ApiError
     */
    public static getAllLeadDeals({
        leadId,
        page,
        size = 10,
        sortBy = 'dateUpdate',
        sortDir = 'asc',
    }: {
        /**
         * The lead ID to filter by
         */
        leadId: number,
        /**
         * The page number for pagination
         */
        page?: number,
        /**
         * The number of items page for pagination
         */
        size?: number,
        /**
         * The field to sort the results by
         */
        sortBy?: string,
        /**
         * The sorting direction
         */
        sortDir?: string,
    }): CancelablePromise<PageDealDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/deal/lead-deals/{leadId}',
            path: {
                'leadId': leadId,
            },
            query: {
                'page': page,
                'size': size,
                'sortBy': sortBy,
                'sortDir': sortDir,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteDeal1({
        id,
    }: {
        /**
         * The id of the deal to delete
         */
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/custom/deal/deleteDeal/{id}',
            path: {
                'id': id,
            },
        });
    }
}
